import Admins from '@/views/Admin/index';
import { requiresAdminAccess } from '@/router/helpers';

export default [
  {
    path: '/admins',
    name: 'Admins',
    component: Admins,
    beforeEnter: requiresAdminAccess,
    meta: {
      roles: ['ADMINISTRATOR'],
      title: 'Админууд',
    },
  },
];
